import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  UseDisclosureReturn,
} from "@chakra-ui/react";
import React, { Dispatch, SetStateAction } from "react";
import { FormattedMessage } from "react-intl";

interface RefillAlertDialogProps {
  hookState: [
    (() => void | undefined) | undefined,
    Dispatch<SetStateAction<(() => void | undefined) | undefined>>
  ];
  disclosure: UseDisclosureReturn;
}

const RefillAlertDialog: React.FC<RefillAlertDialogProps> = ({
  hookState,
  disclosure,
}) => {
  const cancelRef = React.useRef<any>(undefined);
  const { isOpen, onClose, onOpen } = disclosure;

  React.useEffect(() => {
    if (hookState[0] !== undefined) {
      onOpen();
    } else {
      onClose();
    }
  }, [hookState, onClose, onOpen]);

  const onConfirm = () => {
    hookState[1](undefined);
  };

  const onCancel = () => {
    if (hookState[0]) {
      hookState[0]();
      hookState[1](undefined);
    }
  };

  return (
    <>
      <AlertDialog
        isOpen={isOpen}
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isCentered
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="medium">
              <FormattedMessage id="cask.orders.bottling.info.after.alert.title" />
            </AlertDialogHeader>

            <AlertDialogBody>
              <FormattedMessage id="cask.orders.bottling.info.after.alert.desc" />
            </AlertDialogBody>

            <AlertDialogFooter>
              <Button colorScheme="brand" ref={cancelRef} onClick={onCancel}>
                <FormattedMessage id="cask.orders.bottling.info.after.alert.refill" />
              </Button>
              <Button onClick={onConfirm} ml={3}>
                <FormattedMessage id="cask.orders.bottling.info.after.alert.confirm" />
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </>
  );
};

export default RefillAlertDialog;
